import { eLynxObjectTypeEnum } from "../../../common/enums/eLynxObjectType";
import { IAuditTrailFilter } from "../../../services/audit-reporting-data-service/AuditReportingDataService";
import { AuditActionEnum } from "../../../services/audit-reporting-data-service/Models";

export type AuditFilterFormValuesType = {

} & IAuditTrailFilter;

export const defaultFormValues: AuditFilterFormValuesType = {

    action: AuditActionEnum.None,
    userLogin: '',
    objectName: '',
    objectType: eLynxObjectTypeEnum.None,
    oldValue: '',
    newValue: '',
    additionalInfo: '',
    maxRows: 0
};

const AuditFilterUtils = {

    mapToModel: (formValues: AuditFilterFormValuesType): IAuditTrailFilter => {

        const auditAction = +(formValues.action ?? AuditActionEnum.None);
        const objectType = +(formValues.objectType ?? eLynxObjectTypeEnum.None);
   
        const item: IAuditTrailFilter = {

            action: auditAction !== AuditActionEnum.None ? auditAction : undefined,
            userLogin: formValues.userLogin?.trim() === '' ? undefined : formValues.userLogin?.trim(),
            objectName: formValues.objectName?.trim() === '' ? undefined : formValues.objectName?.trim(),
            objectType: objectType !== eLynxObjectTypeEnum.None ? objectType : undefined,
            oldValue: formValues.oldValue?.trim() === '' ? undefined : formValues.oldValue?.trim(),
            newValue: formValues.newValue?.trim() === '' ? undefined : formValues.newValue?.trim(),
            additionalInfo: formValues.additionalInfo?.trim() === '' ? undefined : formValues.additionalInfo?.trim(),
            maxRows: formValues.maxRows,
            startDate: formValues.startDate,
            endDate: formValues.endDate
        };

        return item;
    }
};

export default AuditFilterUtils;